// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//Footer to bottom
jQuery(document).ready(function() {
  var elmcheck = jQuery('#footerid');
  if(typeof(elmcheck) != 'undefined' && elmcheck != null){
    var contentHeight = jQuery(window).height();
    var footerHeight = jQuery('.footer').height();
    var footerTop = jQuery('.footer').position().top + footerHeight;
    if (footerTop < contentHeight) {
        jQuery('.footer').css('margin-top', -103 + (contentHeight - footerTop) + 'px');
    }
  }
});

//Sub-Menu
(function($) {
    $('li').each(function(){ 
        var lt = $(this).find('ul').length;
        var theid = $(this).attr('id');
        if(lt != 0){
            $(this).addClass('dropdown');
            $(this).find('a').first().addClass('dropdown-toggle');
            $(this).find('a').first().attr('href','#');
            $(this).find('a').first().attr('data-toggle','dropdown');
            $(this).find('a').first().attr('aria-haspopup','true');
            $(this).find('a').first().attr('aria-expanded','false');
            $(this).find('a').first().attr('id','navbarDropdownMenuLink'+theid);
            $(this).find('ul').addClass('dropdown-menu');
            $(this).find('ul').attr('aria-labelledby','navbarDropdownMenuLink'+theid); 
            $(this).find('ul > li > a').addClass('dropdown-item');
        }
    });
    $(window).on('resize', function() {
        if($(window).width() < 600) {
            $('#socialmedia').removeClass('text-right');
            $('#socialmedia').addClass('text-left');
        }else{
            $('#socialmedia').removeClass('text-left');
            $('#socialmedia').addClass('text-right');
        }
    });
    if($(window).width() < 600) {
        $('#socialmedia').removeClass('text-right');
        $('#socialmedia').addClass('text-left');
    }else{
        $('#socialmedia').removeClass('text-left');
        $('#socialmedia').addClass('text-right');
    }

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/main.js